import { DeleteIcon } from 'cokitchen-icons';
import React from 'react';
import usePricingContext from 'contexts/pricing.context';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import CurrencyInput from 'components/base/currency-input';
import { ENUM_UNIT } from 'models/common.model';
import { BaseMealItemType } from 'models/pricing.model';
import { ConversionListType } from 'models/pricing.model';

import MealMixesSelect from 'pages/main-store/pricing/base-meals/edit-base-meals/meal-mixes-dropdown';

const LinkBaseMeal = () => {
  const { baseMealsFormData, setBaseMealFormData, setSelectedBaseMeal, selectedBaseMeal } =
    usePricingContext();

  const addItems = (type: 'items') => {
    let newVendors = [...baseMealsFormData];
    const newVendor = selectedBaseMeal;
    if (!newVendor) return;
    newVendor[type] = [...newVendor[type], { mix_id: '', quantity: '' }];
    newVendors = newVendors.map((_, i) => (i === newVendor.itemIndex ? newVendor : _));
    setSelectedBaseMeal(newVendor);
    setBaseMealFormData(newVendors);
  };
  const removeItems = (itemIndex: number, type: 'items') => {
    let newVendors = [...baseMealsFormData];
    const newVendor = selectedBaseMeal;
    if (!newVendor || !newVendor[type]?.length) return;
    if (newVendor[type].length < 2) return;
    newVendor[type] = newVendor[type].filter((_, idx) => idx !== itemIndex);
    newVendors = newVendors.map((_, i) => (i === newVendor.itemIndex ? newVendor : _));
    setSelectedBaseMeal(newVendor);
    setBaseMealFormData(newVendors);
  };
  const handleInputChange = (
    itemIndex: number,
    value: string | number | ENUM_UNIT,
    name: keyof BaseMealItemType,
    type: 'items',
    ingredient?: ConversionListType
  ) => {
    let newVendors = [...baseMealsFormData];
    const newVendor = selectedBaseMeal;
    if (!newVendor) return;
    const newItems = newVendor[type]?.map((b) => ({ ...b }));

    newItems[itemIndex][name] = value as any;
    if (name == 'mix_id') {
      newItems[itemIndex]['meal'] = ingredient;
      // newItems[itemIndex]['mix_id'] = newVendor.id;
    }
    newVendor[type] = newItems;
    newVendors = newVendors.map((_, i) => (i === newVendor.itemIndex ? newVendor : _));
    setSelectedBaseMeal(newVendor);
    setBaseMealFormData(newVendors);
  };
  return (
    <div>
      <div className='flex justify-between mb-6'>
        <h3 className='text-xl font-semibold'>Provide excel meal details</h3>
      </div>

      {selectedBaseMeal?.base_meal_id ? (
        <div className='  py-3'>
          <Table headers={['Excel meal', 'Price per unit', 'Quantity', 'Cost', '']}>
            {selectedBaseMeal?.items.map(({ quantity, mix_id, meal }, itemIndex) => {
              return (
                <TableRow key={itemIndex}>
                  <TableData>
                    <MealMixesSelect
                      {...{
                        handleInputChange,
                        mix_id,
                        itemIndex,
                        type: 'items',
                        meal
                      }}
                    />
                  </TableData>
                  <TableData>
                    <CurrencyInput
                      value={meal?.min_price}
                      onChange={(e) => {
                        console.log(e);
                      }}
                      disabled
                      placeholder=' 2,000'
                    />
                  </TableData>

                  <TableData>
                    <CurrencyInput
                      containerClassname='w-[220px]'
                      name='quantity'
                      placeholder=' 2,000'
                      hasUnit
                      hideCurrency
                      value={quantity}
                      unitValue={meal?.portion_type}
                      disableUnit
                      decimalsLimit={2}
                      onChange={(value) => handleInputChange(itemIndex, value, 'quantity', 'items')}
                    />
                  </TableData>
                  <TableData>
                    <CurrencyInput
                      {...(meal?.min_price
                        ? {
                            value: parseFloat(meal.min_price) * Number(quantity)
                          }
                        : {})}
                      onChange={(e) => {
                        console.log(e);
                      }}
                      disabled
                      placeholder=' 2,000'
                    />
                  </TableData>
                  <TableData>
                    <button
                      onClick={() => removeItems(itemIndex, 'items')}
                      className='min-w-[30px] min-h-[30px] max-w-[30px] max-h-[30px] flex justify-center items-center rounded-full hover:bg-[#FEDDE2] ease-in-out duration-300 transition-colors cursor-pointer text-[#E60A2B] '>
                      <DeleteIcon />
                    </button>
                  </TableData>
                </TableRow>
              );
            })}
          </Table>

          <button
            onClick={() => addItems('items')}
            className='text-[#0080E5] font-medium text-sm mt-1'>
            + Add excel meal
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default LinkBaseMeal;
